/* eslint-disable arrow-parens */
/* eslint-disable operator-linebreak */
// helpers
import { parseLocale } from '@tesla/parse-locale';
import { makeActionCreator } from '../../../lib/Utils';
import { HOME, MAP_INITIAL_ZOOM } from '../../../lib/Constants';

// actions
import { updateHeaderAll } from '../../Header/actions';
import { hydrateVehicleData } from '../../Vehicle/actions';
// eslint-disable-next-line import/no-cycle
import { restorePlaces } from '../../Places/actions';
// eslint-disable-next-line import/no-cycle
import { updateRouteBtnAll } from '../../RouteBtn/actions';
// eslint-disable-next-line import/no-cycle
import { updateStartOverBtnLabel } from '../../StartOverBtn/actions';
// eslint-disable-next-line import/no-cycle
import { updateCancelBtnLabel } from '../../CancelBtn/actions';
import { updateDirectionsLabels } from '../../Directions/actions';
import { updateAddStopBtnLabel } from '../../AddStopBtn/actions';
// eslint-disable-next-line import/no-cycle
import {
  setGoogleMapZoom,
  setGoogleMapLanguage,
  setGoogleMapRegion,
} from '../../GoogleMap/actions';
import { hydrateTooltip } from '../../Tooltip/actions';
import { hydrateRouteSummary } from '../../RouteSummary/actions';
import { hydrateErrorMsgErrors } from '../../ErrorMsg/actions';
import { hydrateSuperchargersBody } from '../../Superchargers/actions';
import { hydrateDestinationChargersData } from '../../DestinationChargers/actions';

// data
import localEPA from '../../../data/localEPA';

export const APP_DETECT_MOBILE = 'APP_DETECT_MOBILE';
export const detectAppMobile = makeActionCreator(APP_DETECT_MOBILE);
export function updateDevice() {
  const windowWidth = Math.max(
    document.documentElement.clientWidth,
    window.innerWidth || 0,
  );
  const windowHeight = Math.max(
    document.documentElement.clientHeight,
    window.innerHeight || 0,
  );

  return {
    isMobile: windowWidth <= 768,
    windowWidth,
    windowHeight,
  };
}

function isImperial(region, type = 'distance') {
  if (type === 'volume') {
    return region === 'US';
  }
  return region === 'US' || region === 'GB';
}

/**
 * Sets the app unit system based on Country code.
 * retrieves translated unit related string values from JSON file in public/index.html.
 */
function getLocaleUnit(region, unit) {
  const localSystemDistance =
    region === 'US' || region === 'GB' ? 'imperial' : 'metric';
  const localSystemVolume = region === 'US' ? 'imperial' : 'metric';
  const variant = region === 'JP' || region === 'DK' ? 'alt' : 'default';

  function isShortVersion() {
    return region === 'JP' || region === 'DK'
      ? unit['km/L']
      : unit.liters_per_100km;
  }

  return {
    system: {
      distance: localSystemDistance,
      liquid: localSystemVolume,
      variant,
    },
    distance: {
      default: {
        singular: isImperial(region) ? unit.mile : unit.kilometer,
        plural: isImperial(region) ? unit.miles : unit.kilometers,
      },
      shorthand: isImperial(region) ? unit.mi : unit.km,
      smallDistanceShorthand: isImperial(region) ? '' : unit.m,
    },
    volume: {
      default: {
        singular: isImperial(region, 'volume') ? unit.gallon : unit.liter,
      },
    },
    fuelEfficiency: isImperial(region) ? unit.MPG : isShortVersion(region),
    localEPA: localEPA[region],
  };
}

export const APP_SET_INITIAL_STATE = 'APP_SET_INITIAL_STATE';
export function setAppInitialState(globalGlossary) {
  const { App: { locale = 'en_US' } = {} } = window.tesla || {};
  const { country: region, lang: language } = parseLocale(locale);

  return {
    type: APP_SET_INITIAL_STATE,
    app: {
      unit: getLocaleUnit(region, globalGlossary),
      locale,
      region,
      language,
    },
  };
}

export const APP_CAPTURE_STATE = 'APP_CAPTURE_STATE';
export const captureAppState = makeActionCreator(
  APP_CAPTURE_STATE,
  'prevState',
);

export const APP_UPDATE_LOADING = 'APP_UPDATE_LOADING';
export const updateAppLoading = makeActionCreator(
  APP_UPDATE_LOADING,
  'isLoading',
);

export const APP_TOGGLE_EASTER_EGG = 'APP_TOGGLE_EASTER_EGG';
export const toggleEasterEgg = makeActionCreator(
  APP_TOGGLE_EASTER_EGG,
  'easterEgg',
);

function getUpdatedPlacesFields(data) {
  return {
    fields: [
      {
        defaultText: data.Places.fields[0].defaultText,
        id: 'j8ous4tft',
        lat: 0,
        lng: 0,
        address: '',
        shortAddress: '',
        country: '',
        order: 0,
      },
      {
        defaultText: data.Places.fields[1].defaultText,
        id: 'j8ous4tgt',
        lat: 0,
        lng: 0,
        address: '',
        shortAddress: '',
        country: '',
        order: 1,
      },
    ],
    numberOfStopoversSingular: data.Places.numberOfStopoversSingular,
    numberOfStopoversPlural: data.Places.numberOfStopoversPlural,
  };
}

export const APP_PARSE_TTP = 'APP_PARSE_TTP';

export function parseAppTTP(data) {
  const { 'Trip_Planner/All': appContent, 'Glossary/Generic': globalGlossary } = data;

  return (dispatch, getState) => {
    // App
    dispatch(setAppInitialState(globalGlossary));

    // GoogleMap
    // TODO: thunk
    dispatch(setGoogleMapZoom(MAP_INITIAL_ZOOM));
    const { language, region } = getState().App;

    dispatch(setGoogleMapLanguage(language));
    dispatch(setGoogleMapRegion(region));
    dispatch(toggleEasterEgg(HOME));

    // Header
    dispatch(updateHeaderAll(appContent.Header));

    // Vehicle
    dispatch(hydrateVehicleData(appContent.Vehicle));

    // Places
    dispatch(restorePlaces(getUpdatedPlacesFields(appContent)));

    // RouteBtn
    dispatch(updateRouteBtnAll(appContent.RouteBtn));

    // StartOverBtn
    dispatch(updateStartOverBtnLabel(appContent.StartOverBtn.label));

    // Directions
    dispatch(updateDirectionsLabels(appContent.Directions));

    // CancelBtn
    dispatch(updateCancelBtnLabel(appContent.CancelBtn.label));

    // RouteSummary
    dispatch(hydrateRouteSummary(appContent.RouteSummary));

    // ToolTip
    dispatch(hydrateTooltip(appContent.Tooltip));

    // AddStopBtn
    dispatch(updateAddStopBtnLabel(appContent.AddStopBtn.label));

    // ErrorMsg
    dispatch(hydrateErrorMsgErrors(appContent.ErrorMsg));

    // Superchargers
    dispatch(hydrateSuperchargersBody(appContent.Superchargers.body));

    // Destination Chargers
    dispatch(hydrateDestinationChargersData(appContent.DestinationChargers));

    // TODO: establish a better FOUC strategy
    setTimeout(() => {
      dispatch(updateAppLoading(false));
    }, 400);
  };
}

export const APP_UPDATE_COMPONENT_HEIGHT = 'APP_UPDATE_COMPONENT_HEIGHT';
export const updateAppComponentHeight = makeActionCreator(
  APP_UPDATE_COMPONENT_HEIGHT,
  'component',
  'height',
);
export function updateComponentHeight({ componentHeights }, action) {
  const newState = componentHeights.map(element => {
    if (element.component !== action.component) {
      return element;
    }

    return Object.assign({}, element, { height: action.height });
  });

  return newState;
}
